/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import type { Resource, ResourceTypeEntityResponseCollection } from '@edwin-group/cj-graphql/generated/graphql';
import { QUERY_FETCH_RESOURCE_HUB_PAGE } from '@edwin-group/cj-graphql';

import type { ResourceHubPageQuery, ResourceHubPageQueryVariables } from '@edwin-group/cj-graphql';

import { Loading } from './loading';
import { Link } from 'react-router-dom';
import { startTransition, Suspense, useEffect, useState } from 'react';
import { fetchLatestResourcesByType } from '@/services/resource-hub/resource-hub.service';
import Divider from '@/components/Divider';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import ResourceCard from '@/components/Card/Resource';
import { useSuspenseQuery } from '@apollo/client';
// import FavoriteButton from '@/components/Favorite/FavoriteButton';
// import FavoriteButton from '@/components/Favorite/FavoriteButton';

function renderCards({
  title,
  data,
  viewAll = false,
  showDivider = true,
  viewAllText = 'View All',
  isWellbeingCalendar = false,
}: {
  title: string;
  data: Resource[];
  showDivider?: boolean;
  viewAll?: boolean;
  viewAllText?: string;
  isWellbeingCalendar?: boolean;
}) {
  if (!data?.length) {
    return null;
  }

  const firstItem = data[0];
  const type = (firstItem?.attributes?.resourceType as unknown as ResourceTypeEntityResponseCollection)?.data?.[0]
    ?.attributes?.type;

  let viewAllUrl = '/resource-hub';

  if (type) {
    viewAllUrl = `/resource-hub/type/${type}`;
  }

  if (isWellbeingCalendar) {
    viewAllUrl = '/calendar';
  }

  return (
    <AnimatedFadeInComponent key={title} fromBottom>
      <div key={title}>
        <div className="flex items-center justify-between">
          <h3 className="mb-sh-15 font-cadiz text-sh-28-32 font-bold">{title}</h3>
          {viewAll ? (
            <Link className="text-sh-xxxs font-bold text-primary-600" to={viewAllUrl}>
              {viewAllText}
            </Link>
          ) : null}
        </div>
        <div className="grid grid-cols-1 gap-sh-15 md:grid-cols-2 lg:grid-cols-3">
          {data?.map((resource: Resource) => {
            return <ResourceCard resource={resource} key={resource?.attributes?.slug} />;
          })}
        </div>
      </div>
      {showDivider ? <Divider /> : null}
    </AnimatedFadeInComponent>
  );
}

function LatestsComponent() {
  const [resourcesByType, setResourcesByType] = useState<Record<string, Resource[]>>({});

  const { data: resourceHubPage } = useSuspenseQuery<ResourceHubPageQuery, ResourceHubPageQueryVariables>(
    QUERY_FETCH_RESOURCE_HUB_PAGE,
    {
      fetchPolicy: 'cache-first',
    },
  );

  useEffect(() => {
    const fetchAllResources = async () => {
      const latestTypePromises = resourceHubPage?.resourceTypes?.map(async (type) => {
        const resources = await fetchLatestResourcesByType(type?.type || '', 3);
        return { type: type?.type || '', resources: resources?.resources };
      });

      const typesWithLatests = await Promise.all(latestTypePromises ?? []);

      const updatedLatestByType: Record<string, Resource[]> = {};
      typesWithLatests.forEach(({ type, resources }) => {
        updatedLatestByType[type] = resources as unknown as Resource[];
      });

      startTransition(() => {
        setResourcesByType(updatedLatestByType);
      });
    };

    fetchAllResources();
  }, [resourceHubPage?.resourceTypes]);

  return resourceHubPage?.resourceTypes?.map((type) =>
    renderCards({
      title: `${resourceHubPage?.resourceHubPage?.data?.attributes?.latestTitle || 'Latest'} by ${type!.type}` || '',
      data: resourcesByType[type!.type],
      showDivider: true,
      viewAll: resourcesByType[type!.type]?.length > 2,
    }),
  );
}

export default function Latests() {
  return (
    <Suspense fallback={<Loading />}>
      <LatestsComponent />
    </Suspense>
  );
}
